/* Rubedon Research — progressive enhancements. The site works without JS; this adds the cart drawer,
   bundle selector updates, gallery, and the COA database selector. */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const drawerOn = document.body.hasAttribute('data-cart-drawer-enabled');
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  /* ---------- Cart count ---------- */
  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
    $$('[data-cart-count-label]').forEach((el) => { el.textContent = `${count} ${count === 1 ? 'item' : 'items'}`; });
  };

  /* ---------- Drawer ---------- */
  const drawer = () => $('[data-cart-drawer]');
  let lastFocus = null;
  const openDrawer = () => {
    const d = drawer(); if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('drawer-open');
    setTimeout(() => $('.drawer__panel', d).focus(), 50);
    return true;
  };
  const closeDrawer = () => {
    const d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  const renderDrawer = (html) => {
    const d = drawer(); if (!d || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const inner = $('[data-drawer-inner]', doc);
    if (inner) $('[data-drawer-inner]', d).innerHTML = inner.innerHTML;
  };
  const refreshDrawer = async () => {
    const res = await fetch(`${root}?sections=cart-drawer`);
    const data = await res.json();
    renderDrawer(data['cart-drawer']);
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    const cartLink = e.target.closest('.cart-link');
    if (cartLink && drawerOn && drawer()) { e.preventDefault(); refreshDrawer().then(openDrawer); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (drawer() && drawer().classList.contains('is-open')) closeDrawer();
      $$('.menu-drawer[open]').forEach((d) => { d.removeAttribute('open'); $('summary', d).focus(); });
    }
  });

  /* Quantity + remove inside drawer */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const line = btn.closest('[data-line-key]');
    btn.disabled = true;
    const res = await fetch(`${root}cart/change.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.dataset.lineKey, quantity: parseInt(btn.dataset.qtyChange, 10), sections: 'cart-drawer' }),
    });
    const data = await res.json();
    if (data.sections) renderDrawer(data.sections['cart-drawer']);
    if (typeof data.item_count === 'number') updateCount(data.item_count);
  });

  /* RUO acknowledgement in drawer: saved to the cart so it follows the order */
  document.addEventListener('change', (e) => {
    const ack = e.target.closest('[data-ruo-ack]');
    if (!ack) return;
    const form = ack.closest('form');
    fetch(`${root}cart/update.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'RUO acknowledgement': ack.checked ? `Accepted: ${ack.closest('label').textContent.trim()}` : '' } }),
    });
  });

  /* ---------- Add to cart (product page, upsell) ---------- */
  const addToCart = async (form, statusEl, button) => {
    button && (button.disabled = true, button.setAttribute('aria-busy', 'true'));
    try {
      const body = new FormData(form);
      if (drawerOn && drawer()) body.append('sections', 'cart-drawer');
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'This item could not be added.');
      const cart = await (await fetch(`${root}cart.js`)).json();
      updateCount(cart.item_count);
      if (drawerOn && drawer()) {
        if (data.sections) renderDrawer(data.sections['cart-drawer']); else await refreshDrawer();
        openDrawer();
        if (statusEl) statusEl.textContent = '';
      } else if (statusEl) {
        statusEl.className = 'form-status form-status--ok';
        statusEl.innerHTML = `Added to cart. <a href="${root}cart">View cart</a>`;
      }
    } catch (err) {
      if (statusEl) { statusEl.className = 'form-status form-status--error'; statusEl.textContent = err.message; }
    } finally {
      button && (button.disabled = false, button.removeAttribute('aria-busy'));
    }
  };
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart], form[data-upsell-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, $('[data-cart-status]', form), $('[type="submit"]', form));
  });

  /* ---------- Bundle selector ---------- */
  $$('.bundles input[type="radio"]').forEach((radio) => {
    radio.addEventListener('change', () => {
      const price = $('[data-price]'); const refWrap = $('[data-price-ref]');
      if (price) price.textContent = radio.dataset.price;
      if (refWrap) {
        const has = !!radio.dataset.ref;
        refWrap.hidden = !has;
        if (has) { $('[data-ref-val]', refWrap).textContent = radio.dataset.ref; $('[data-save-val]', refWrap).textContent = radio.dataset.save; }
      }
      const url = new URL(window.location.href); url.searchParams.set('variant', radio.value);
      window.history.replaceState({}, '', url);
    });
  });

  /* ---------- Gallery ---------- */
  const main = $('[data-gallery-main] img');
  $$('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!main) return;
      main.removeAttribute('srcset'); main.src = thumb.dataset.src; main.alt = thumb.dataset.alt;
      $$('[data-gallery-thumb]').forEach((t) => t.removeAttribute('aria-current'));
      thumb.setAttribute('aria-current', 'true');
    });
  });

  /* ---------- COA database ---------- */
  const db = $('[data-coa-db]');
  if (db) {
    const tabs = $$('[data-coa-product]', db);
    const showLot = (panel, lot) => {
      const recs = $$('[data-coa-record]', panel);
      let target = recs.find((r) => r.dataset.coaRecord === lot) || recs[0];
      recs.forEach((r) => { r.hidden = r !== target; });
      $$('[data-coa-lot]', panel).forEach((b) => b.setAttribute('aria-pressed', String(target && b.dataset.coaLot === target.dataset.coaRecord)));
      return target ? target.dataset.coaRecord : '';
    };
    const showProduct = (handle, lot, push) => {
      tabs.forEach((t) => {
        const on = t.dataset.coaProduct === handle;
        t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
      });
      let chosenLot = '';
      $$('[data-coa-panel]', db).forEach((p) => {
        const on = p.dataset.coaPanel === handle; p.hidden = !on;
        if (on) chosenLot = showLot(p, lot);
      });
      if (push) {
        const url = new URL(window.location.href);
        url.searchParams.set('product', handle);
        if (chosenLot) url.searchParams.set('lot', chosenLot); else url.searchParams.delete('lot');
        window.history.replaceState({}, '', url);
      }
    };
    // Newest lot first in each product.
    $$('[data-coa-panel]', db).forEach((panel) => {
      const lots = $('[data-coa-lots]', panel);
      $$('[data-coa-lot]', lots).sort((a, b) => b.dataset.date - a.dataset.date).forEach((b) => lots.appendChild(b));
      const recs = $$('[data-coa-record]', panel);
      if (recs.length < 2) lots.hidden = true;
      lots.addEventListener('click', (e) => {
        const b = e.target.closest('[data-coa-lot]'); if (!b) return;
        showLot(panel, b.dataset.coaLot);
        const url = new URL(window.location.href); url.searchParams.set('lot', b.dataset.coaLot); window.history.replaceState({}, '', url);
      });
    });
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => showProduct(t.dataset.coaProduct, null, true));
      t.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        const n = tabs[(i + d + tabs.length) % tabs.length]; n.focus(); n.click();
      });
    });
    const params = new URLSearchParams(window.location.search);
    const startProduct = params.get('product');
    const start = tabs.find((t) => t.dataset.coaProduct === startProduct) || tabs[0];
    if (start) {
      // Newest lot unless a lot is requested
      const panel = $(`[data-coa-panel="${start.dataset.coaProduct}"]`, db);
      const newest = panel && $('[data-coa-lot]', panel);
      showProduct(start.dataset.coaProduct, params.get('lot') || (newest && newest.dataset.coaLot), false);
      if (startProduct) db.scrollIntoView({ block: 'start' });
    }
  }
})();
